export default "__VITE_ASSET__CoHOBOqD__"